/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { List, ListProps } from "@material-ui/core"
import { ReactNode } from "react"
import { Theme } from "../../types"

type Props = {
    children: ReactNode
} & ListProps

function ZebraList({ children, ...props }: Props) {
    return (
        <List {...props} css={styles.root}>
            {children}
        </List>
    )
}

export default ZebraList

const styles = {
    root: (theme: Theme) => css`
        & li:nth-of-type(odd) {
            background: ${theme.colors.grey[100]};
        }
        & li {
            border-radius: ${theme.spaces.smallScale.xxs};
        }
    `,
}
